module.exports = __webpack_public_path__ + "static/family_high-55f259695e96ecd0674059096124513c.mp4";